/**
 * Shared chart/plot color palette used across Monte Carlo plots,
 * phase field visualizations, and utilization indicators.
 */
export const CHART_COLORS = {
  info: "#5A93D1",
  success: "#36D399",
  warning: "#FFC978",
  error: "#FF7C7C",
  gray: "#7F7D87",
  text: "#2D3748",
} as const;
